import localforage from 'localforage';
import { createBrowserClientSupa } from './supabase/createBrowserClient';
import { getQuizAnswers, LOCAL_QUIZ_ANSWER_KEY } from './get-quiz-answers';

export const trackQuizAnswer = async (
  exampleId: string,
  isCorrect: boolean,
  userId?: string,
) => {
  if (!userId) {
    const { data: quizAnswers, error } = await getQuizAnswers();
    if (error) {
      // TO-DO: Deal with this error
      console.log('Error getting quiz answers from local:', error);
      return;
    }
    const newQuizAnswers = [
      ...quizAnswers,
      {
        example_id: exampleId,
        user_id: 'local',
        created_at: new Date().toISOString(),
        correct: isCorrect,
        quizz_type: 1,
      },
    ];

    await localforage.setItem(LOCAL_QUIZ_ANSWER_KEY, newQuizAnswers);
    return;
  }
  const supabase = createBrowserClientSupa();
  const { error } = await supabase.from('quizz_answers').insert({
    example_id: exampleId,
    correct: isCorrect,
    quizz_type: 1,
    user_id: userId,
  });
  if (error) {
    console.log('error', error);
  }
};
